module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_primaerlogo_pos.2cfc4e0e.svg";